import { render, staticRenderFns } from "./sorundetaynew.vue?vue&type=template&id=5de1697c&"
import script from "./sorundetaynew.vue?vue&type=script&lang=js&"
export * from "./sorundetaynew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports